// src/components/shared/Logo.js
// Logo Fynho réutilisable - remplace l'image ici quand tu auras ton .webp - NE PAS MODIFIER LA STRUCTURE

import React from 'react';
import { useTheme } from '../../hooks/useTheme';

// ⬇️ QUAND TU AURAS TON LOGO : décommente la ligne suivante et mets ton fichier dans src/assets/
// import logoImage from '../../assets/logo.webp';
const logoImage = null; // ← Remplace par: logoImage = ton import

const Logo = ({ size = 'medium', showText = true }) => {
  const { theme } = useTheme();

  const sizes = {
    small: { box: '32px', font: '18px', text: '18px' },
    medium: { box: '40px', font: '22px', text: '22px' },
    large: { box: '56px', font: '30px', text: '30px' },
  };
  const s = sizes[size] || sizes.medium;

  const styles = {
    container: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
    },
    imageBox: {
      width: s.box,
      height: s.box,
      borderRadius: '10px',
      objectFit: 'cover',
      display: 'block',
    },
    // Placeholder propre (monogramme F doré) en attendant l'image webp
    placeholderBox: {
      width: s.box,
      height: s.box,
      borderRadius: '10px',
      backgroundColor: theme.gold,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: s.font,
      fontWeight: '800',
      color: theme.mode === 'light' ? '#FFFFFF' : '#0A0E1A',
      fontFamily: '-apple-system, sans-serif',
    },
    text: {
      fontSize: s.text,
      fontWeight: '700',
      color: theme.gold,
      lineHeight: '1',
      letterSpacing: '-0.5px',
    },
  };

  return (
    <div style={styles.container}>
      {logoImage ? (
        <img src={logoImage} alt="Fynho" style={styles.imageBox} />
      ) : (
        <div style={styles.placeholderBox}>F</div>
      )}
      {showText && <span style={styles.text}>Fynho</span>}
    </div>
  );
};

export default Logo;